/* eslint-disable react/prop-types */
import React, { useState, useEffect, MouseEvent } from "react";
import Grid from "@mui/material/Grid";
// import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { Icon } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import Divider from "@mui/material/Divider";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import moment from "moment";
import { getSmsHistory, sendSMS } from "network/service";


let smsTableHeader = [
    { Header: "Mobile", accessor: "mobile" },
    { Header: "Time", accessor: "time" }
];

// Material Dashboard 2 React Components
function SMSDialog(props) {
    const [notiDetails, setShowDetails] = useState({ show: false });
    const [mobile, setMobile] = useState("");
    const [data, setData] = useState([]);

    const closeSB = () => setShowDetails({ ...notiDetails, show: false });

    useEffect(() => {
        console.log("modal useEffect");
        if (props.details) {

        }
    }, []);

    useEffect(() => {
        getSmsHistory(`package=${props.details._id}`).then((resp) => {
            console.log(resp.data);
            let temp = [];
            for (let dt of resp.data) {
                temp.push({
                    mobile: dt.mobile,
                    time: moment(dt.createdAt).format("DD-MM-YYYY HH:mm:ss")
                });
            }
            setData(temp);
        }).catch((err) => {
            console.log(err);
        })
    }, [setData]);

    const send_tracking_sms = () => {
        if (mobile.length == 10) {
            sendSMS({
                parcel: props.details._id,
                mobile: `91${mobile}`
            }).then((resp) => {
                console.log(resp.data);
                props.apply();
            }).catch((err) => {
                console.log(err);
                setShowDetails({
                    show: true,
                    color: "error",
                    title: "Failed",
                    message: "Unable to send sms. Try later",
                    icon: "close"
                })
            })
        }
    }


    const renderSB = (
        <MDSnackbar
            color={notiDetails.color}
            icon={notiDetails.icon}
            title={notiDetails.title}
            content={notiDetails.message}
            dateTime=""
            open={notiDetails.show}
            onClose={closeSB}
            close={closeSB}
            bgWhite
        />
    );


    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            onClose={props.handleclose}
        >
            <DialogContent style={{ minWidth: 500, height: 'auto' }}>
                <FormGroup>
                    <MDBox component="form" noValidate width="100%">
                        <MDTypography
                            variant="h5"
                            fontWeight="bold"
                            color="dark"
                        >
                            {"Tracking SMS"}
                        </MDTypography>

                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            spacing={2}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around" }}
                        >
                            <Grid item xs={12} xl={8}>
                                <MDInput
                                    fullWidth
                                    type="number"
                                    label="Mobile"
                                    value={mobile}
                                    error={!(mobile.length == 10)}
                                    onChange={(event) => {
                                        setMobile(event.target.value);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} xl={4}>
                                <MDButton variant="contained" sx={{ width: "100%" }} color="info" onClick={() => {
                                    send_tracking_sms();
                                }}>SEND SMS</MDButton>
                            </Grid>
                        </Grid>
                        <Divider />
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns: smsTableHeader, rows: data }}
                                entriesPerPage={false}
                                showTotalEntries={false}
                            />
                        </MDBox>
                        {renderSB}
                    </MDBox>
                </FormGroup>
            </DialogContent>
        </Dialog >
    )
};

export default SMSDialog;